import React, {Component} from 'react'
import {Container, Row, Col} from 'react-grid-system'

// STYLES
import styled from 'styled-components'
// import Colors from "../../shared/colors";

// HELPERS
import {Section} from '../../shared/helpers'

// COMPONENTS
import Title from '../../components/title/title.component'

// IMAGE
import BgImage from '../../assets/images/background-vantagens@2x.png'

// ICONS
import Icon1 from '../../assets/images/ic-vantagens-1.png'
import Icon2 from '../../assets/images/ic-vantagens-2.png'
import Icon3 from '../../assets/images/ic-vantagens-3.png'
import Icon4 from '../../assets/images/ic-vantagens-4.png'

export default class Advantages extends Component {
  render () {
    const { t, id } = this.props
    return (
      <SectionBackground id={id}>
        <Section>
          <Container>
            <Title color={'#FFF'} text={t('Vantagens')} />
            <Row>
              <Col md={6} sm={12}>
                <AdvantagesContent>
                  <AdvantagesIcon>
                    <img src={Icon1} alt='' />
                  </AdvantagesIcon>
                  <AdvantagesText>
                    <p>{t('A_Advantages1')}</p>
                  </AdvantagesText>
                </AdvantagesContent>
              </Col>
              <Col md={6} sm={12}>
                <AdvantagesContent>
                  <AdvantagesIcon>
                    <img src={Icon2} alt='' />
                  </AdvantagesIcon>
                  <AdvantagesText>
                    <p>{t('A_Advantages2')}</p>
                  </AdvantagesText>
                </AdvantagesContent>
              </Col>
              <Col md={6} sm={12}>
                <AdvantagesContent>
                  <AdvantagesIcon>
                    <img src={Icon3} alt='' />
                  </AdvantagesIcon>
                  <AdvantagesText>
                    <p>{t('A_Advantages3')}</p>
                  </AdvantagesText>
                </AdvantagesContent>
              </Col>
              <Col md={6} sm={12}>
                <AdvantagesContent>
                  <AdvantagesIcon>
                    <img src={Icon4} alt='' />
                  </AdvantagesIcon>
                  <AdvantagesText>
                    <p>{t('A_Advantages4')}</p>
                  </AdvantagesText>
                </AdvantagesContent>
              </Col>
            </Row>
            <Sentence>
              {t('A_Advantages5')}
            </Sentence>
          </Container>
        </Section>
      </SectionBackground>
    )
  }
}

const SectionBackground = styled.div`
    width: 100%;
    background-size: cover;
    background-position: fixed;
    background-repeat: no-repeat;
    background-image:url(${BgImage});
`

const AdvantagesContent = styled.div`
    display: flex;
    margin-top: 50px;

    @media screen and (max-width: 767px) {
        margin-top: 25px;
        display: block;
        text-align: center;
    }
`
const AdvantagesIcon = styled.div`
    @media screen and (max-width: 767px) {
        margin-bottom: 25px;
        margin-top: 45px;
    }
`
const AdvantagesText = styled.div`
    text-align: left;
    margin-left: 15px;
    color: #FAFAFA;
    font-family: "Source Sans Pro";
    font-size: 18px;
    line-height: 23px;
    text-shadow: 0 1px 10px 0 rgba(0,0,0,0.3);
    p{
        margin: 0;
    }

    @media screen and (max-width: 767px) {
       text-align: center;
    }
`

const Sentence = styled.h3`
    color: #FFF;
    font-family: Dosis;
    font-size: 36px;
    font-weight: 300;
    line-height: 46px;
    text-align: center;
    text-shadow: 0 1px 10px 0 rgba(0,0,0,0.3);
    margin-top: 100px;
    margin-bottom: 0px;

    @media screen and (max-width: 767px) {
        margin-top: 65px;
    }
`



// WEBPACK FOOTER //
// ./src/sections/advantages/advantages.section.js